import React, {Fragment} from 'react';

import {
    SimpleForm,
    Edit,
    Create,
    FileInput,
    FileField,
    SelectInput,
    maxLength, TextInput
} from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import Avatar from "@material-ui/core/Avatar";
import {Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import ReportTemplateIcon from "./ReportTemplateIcon";
import SitesStore from "../stores/SitesStore";
import simpleMemoize from "../../framework/util/forms/SimpleMemoize";
import ReportTemplatesStore from "../stores/ReportTemplatesStore";
import Container from "@material-ui/core/Container";
import {Button} from "@material-ui/core";
import { saveAs } from 'file-saver';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const idUnique = simpleMemoize(async value => {
    if (!value) {
        return "Required";
    }
    try {
        const existing = await new ReportTemplatesStore().findById(value);
        if (existing) {
            return "Already taken!";
        }
    } catch (error) {
        // Ignore
    }
});

const IdInput = (props) => {
    return (
        <TextInput
            label="Id"
            source="id"
            variant='outlined'
            helperText={'An unique identifier for this report file, typically the filename.'}
        >
        </TextInput>);
}


const ReportFileInput = (props) => {
    return (
        <FileInput source="reportZip" label="Report File Zip" accept={['.zip']}>
            <FileField source="reportZip" title="reportZip" />
        </FileInput>);
}


const Header = (props) => {
    const classes = useStyles();
    return (
        <Container component="main" maxWidth="xs">
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <ReportTemplateIcon/>
                </Avatar>
                <Typography component="h1" variant="h5">
                    Report Template
                </Typography>
                <br/>
                <Typography component="h5">
                    Upload report templates to use as in other flows.
                </Typography>
            </div>
        </Container>
    );
}

const TagsChooser = (props) => {

    const choices = [{ id: 'Pallet Manifest', name: 'Pallet Manifest'},{id:'Other', name: 'Other' }];

    return (<SelectInput source="category" choices={choices} />);


}

const transformAddId = data => {
    console.log("transform data", {data});
    const after = {
        ...data,
    }
    const id = data.reportZip.reportZip;
    after['id'] = id;
    console.log("transform data after", {after});
    return after;
};

const FormContentsCreate = (props) => {
    return (
        <SimpleForm {...props} redirect="list" >
            <ReportFileInput/>
            <TagsChooser/>
            <RichTextInput source="notes" label={'Additional Notes'}/>

        </SimpleForm>
    );
}

const downloadFile = (props)=> {
    const file = props.record.reportZip.src;
    const fileName = props.id;
    console.log('saveAs', {file}, {fileName})
    saveAs(file, fileName);
}

const FormContentsEdit = (props) => {
    return (
        <Container component="main" maxWidth="xs">
            {/*{JSON.stringify(props)}*/}
            <SimpleForm {...props} redirect="list">
                <IdInput disabled={true}/>
                <TagsChooser/>
                <RichTextInput source="notes" label={'Additional Notes'}/>
                <FileField source="reportZip.src" title="id" />
                <Button fullWidth variant="contained" onClick={()=>downloadFile(props)}>Download {props.id}</Button>
            </SimpleForm>
        </Container>
    );
}


export const ReportTemplateEditCommons = ({record, ...props}) => {
    const classes = useStyles();
    return (
        <Container component="main" maxWidth="xs">
                <Header></Header>
                <Edit {...props} >
                    <FormContentsEdit {...props}/>
                </Edit>

        </Container>
    );
}

export const ReportTemplateCreateCommons = (props) => {
    const classes = useStyles();
    return (
        <Container component="main" maxWidth="xs">
                <Header></Header>
                <Create {...props} transform={transformAddId} >
                    <FormContentsCreate {...props}/>
                </Create>
        </Container>
    );
}
